let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hba2k")).then(() => parcelRequire('2TsXy'));